import { InjectionToken, ValueProvider } from '@angular/core';

export type OrderApiOrigin = { order: string; orderHistory: string; orderReferenceId: string; survey: string };
export const ORDER_API_ORIGIN = new InjectionToken<OrderApiOrigin>('Order API Origin');
export const provideOrderApiOrigin = (origin: OrderApiOrigin): ValueProvider => ({
  provide: ORDER_API_ORIGIN,
  useValue: origin,
});
